import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef, SimpleChanges, OnChanges } from '@angular/core';
import { RoleService } from '../../shareModule/services/roles/role.service';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { CustomerService } from '../../shareModule/services/customer.service';
@Component({
    selector: 'app-map-single-text',
    templateUrl: './map-single-text.component.html',
    styleUrls: ['./map-single-text.component.scss']
})
export class MapSingleTextComponent implements OnInit, OnDestroy, OnChanges {
    @Input() filter: string = '';

    public text: string = '';
    public isEditing: boolean = false;
    public editedText: string = '';
    public isSaving: boolean = false;
    public isEditable: boolean = false;

    private destroy$ = new Subject<void>();

    constructor(
        private roleService: RoleService,
        private toastr: ToastrService,
        private cdr: ChangeDetectorRef,
        private customerService: CustomerService
    ) { }

    ngOnInit(): void {
        this.checkUserPermissions();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['filter']) {
            this.loadText();
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private checkUserPermissions(): void {
        // Check if user is admin

        this.roleService.rolesSubject.subscribe((response) => {
            this.isEditable = response?.userType?.includes('ADMIN');
            this.cdr.detectChanges();
        });
    }

    private loadText(): void {
        if (!this.filter) return;
        this.customerService.getMapSingleText({ filter: this.filter })
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: any) => {
                    const data = response?.body || {};
                    this.text = data?.text || '';
                    this.editedText = this.text;
                    this.cdr.detectChanges();
                },
                error: (error) => {
                    console.error('Error loading map single text:', error);
                }
            });
    }

    public toggleEdit(): void {
        if (this.isEditing) {
            this.saveText();
        } else {
            this.startEdit();
        }
    }

    public startEdit(): void {
        this.isEditing = true;
        this.editedText = this.text;
    }

    public saveText(): void {
        if (!this.filter) return;

        this.isSaving = true;
        this.customerService.addMapSingleText({
            filter: this.filter,
            text: this.editedText
        })
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: any) => {
                    this.text = this.editedText;
                    this.isEditing = false;
                    this.isSaving = false;
                    this.toastr.success('Text saved successfully');
                    this.cdr.detectChanges();
                },
                error: (error) => {
                    console.error('Error saving map single text:', error);
                    this.isSaving = false;
                    this.toastr.error('Failed to save text');
                    this.cdr.detectChanges();
                }
            });
    }

    public cancelEdit(): void {
        this.isEditing = false;
        this.editedText = this.text;
        this.cdr.detectChanges();
    }
}
